import AppleIcon from "@mui/icons-material/Apple";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";

export default function PurchasesTable(props) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell></TableCell>
						<TableCell>ID</TableCell>
						<TableCell>Price</TableCell>
						<TableCell>Product ID</TableCell>
						<TableCell>User ID</TableCell>
						<TableCell>Username</TableCell>
						<TableCell>PurchaseId</TableCell>
						<TableCell>Date</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props?.purchases?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.store === 0 ? <AppleIcon /> : <Iconify icon={"eva:google-outline"} />}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.storePurchaseId}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.price / 100} {"$"}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.productId.toString()}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.userId.toString()}
							</TableCell>
							<TableCell component="th" scope="row">
								<a href={`/dashboard/profile?user_id=${row.userId}`}>{row.username}</a>
							</TableCell>
							<TableCell component="th" scope="row">
								{row.purchaseId.toString().length > 20 ? `${row.purchaseId.toString().slice(0, 20)}...` : row.purchaseId.toString()}
							</TableCell>
							<TableCell component="th" scope="row">
								{fDateTime(row.purchaseDate)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
